import { Input, Label } from "reactstrap";
import { LOCATION_CHECKBOX_DATA } from "../../../../Data/JobSearch";

const LocationCheckBox = () => {
  return (
    <div className="location-checkbox">
      {LOCATION_CHECKBOX_DATA.map((data, index) => (
        <Label className="d-block" for={`checkbox-${index}`} key={index} check>
          <Input className="checkbox_animated" id={`checkbox-${index}`} type="checkbox" />
          {data.location}
          <span className="d-block">{data.locationSpanText}</span>
        </Label>
      ))}
    </div>
  );
};

export default LocationCheckBox;
